export const enum FunnelStatus {
  DRAFT = 'draft',
  PENDING_CHANGES = 'pendingChanges',
  DEPLOYED = 'deployed',
  UNREACHABLE = 'unreachable',
}
